export const ROUTES = {
  home: { path: '/', title: 'Home' },
  login: { path: '/login', title: 'Login' },
  forgot: { path: '/forgot/:type', title: 'Forgot password' },
  smsCode: { path: '/sms-code/:type', title: 'SMS code' },
  changePassword: { path: '/change-password', title: 'Change Password' },
  success: { path: '/success', title: 'Success' },
  verifyDeviceWarning: { path: '/verify-device-warning', title: 'Device Verification Warning' },
  verifyDevice: { path: '/verify-device', title: 'Device Verification' },
}; 